var path = 'ui-formly/types/input/index.html';
var html = "<input class=\"form-control\" ng-model=\"model[options.key]\" ng-readonly=\"to.readonly\">\r\n<span ng-if=\"to.helpText\" class=\"help-block\">{{to.helpText}}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;